export const twitterConfig = {
	handleName: '@cocoon_space',
	metaImage: {
		height: 628,
		url: '/content/space-default',
		width: 1200,
	},
	pageUrl: 'https://twitter.com/cocoon_space',
} as const
